import "./CompanyHeading.scss"

import { Link } from "react-router-dom"

import { companyAvatarColors } from "@/constants/companyAvatarColor"
import { CompanyBase } from "@/entities/company/company.types"

import CompanyAvatar from "../Avatar/CompanyAvatar"

interface CompanyHeadingProps extends CompanyBase { }

function CompanyHeading(props: CompanyHeadingProps) {
  return (
    <div className="company-heading">
      <div className="company-heading__text">Now editing:</div>
      <CompanyAvatar name={props.title} src={props.logo} backgroundColor={companyAvatarColors.companyAvatarBackgroundColor} letterColor={companyAvatarColors.companyAvatarLetterColor} />
      <div className="company-heading__title">{props.title}</div>
      <Link className="ghost" to={"/companies/" + props.id} />
    </div>
  )
}

export default CompanyHeading
